import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { FilterItemSelectOption } from '@common-modules/common-filters/models/filter-item-select-option';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { SharedConstantsService } from '@common-modules/shared/constants/shared-constants.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseFilterItemComponent } from '../../../core/base-filter-item/base-filter-item.component';
import { BaseSelectFilterItemComponent } from '../../core/base-select-filter-item/base-select-filter-item.component';

const COMPONENT_SELECTOR = 'wlm-day-type-filter-item';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './day-type-filter-item.component.html',
    styleUrls: ['./day-type-filter-item.component.scss'],
    providers: [
        {
            provide: BaseFilterItemComponent,
            useExisting: forwardRef(() => DayTypeFilterItemComponent),
        },
    ],
    standalone: false
})
export class DayTypeFilterItemComponent
  extends BaseSelectFilterItemComponent
  implements OnInit, OnDestroy
{
  data$$ = new BehaviorSubject<Observable<FilterItemSelectOption[]>>(null);
  T_SCOPE = `${AppModules.WlmFilters}.${COMPONENT_SELECTOR}`;
  titleKey = `${this.T_SCOPE}.title`;
  inputSummaryKey = `${this.T_SCOPE}.input-summary`;
  // The state to return when the filter is reset
  defaultSelectedIds = [];

  constructor(private sharedConstants: SharedConstantsService) {
    super();
  }

  ngOnInit(): void {
    this.data$$.next(this.getData$());
    super.onInit();
  }

  getData$(): Observable<FilterItemSelectOption[]> {
    return this.sharedConstants
      .getDayTypesMapping()
      .pipe(
        map((items) =>
          Array.from(items).map((item) => new FilterItemSelectOption(item[0], item[1]))
        )
      );
  }

  getFilterKey(): string {
    return COMPONENT_SELECTOR;
  }

  isValid(): boolean {
    return this.selectedElements && this.selectedElements.length !== 0;
  }

  getFieldNames(): string[] {
    return [this.fieldName];
  }
}
